import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { useFeatureAppConfig } from '../hooks/use-feature-app-config';
import { createApolloClient } from './create-apollo-client';

interface DataServerProps {
  children: React.ReactNode;
}

export const DataServer = ({ children }: DataServerProps) => {
  const { graphQLServerUrl } = useFeatureAppConfig();

  const graphQLServer = graphQLServerUrl || '';
  !graphQLServer && console.error('No value provided for graphQLServer');

  const client = React.useMemo(
    () => createApolloClient(graphQLServer),
    [graphQLServer]
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
